import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import Home from './routes/site/Home'
import AppLayout from './routes/app/AppLayout';
import Menu from './routes/app/public/Menu'
import Login from './routes/app/user/Login'
import Signup from './routes/app/user/Signup'
import Settings from './routes/app/user/Settings'
import App from './routes/app/store/App'
import Recover from './routes/app/user/RecoverPassword'

import Share from './routes/app/store/Share';
import Customize from './routes/app/store/Customize';
import ShopData from './routes/app/store/ShopData';
import Products from './routes/app/store/Products'
import Plans from './routes/app/store/Plans';
import MenuData from './routes/app/store/MenuData';
import PageNotFound from './routes/site/PageNotFound';

import HomePlans from './routes/site/Plans';
import Faq from './routes/site/Faq';

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/plans",
    element: <HomePlans />,
  },
  {
    path: "/faq",
    element: <Faq />,
  },
  {
    path: "admin",
    element: <AppLayout />,
    children: [
      {
        path: "app",
        element: <App />,
        children: [
          {
            path: "share",
            element: <Share />,
          },
          {
            path: "shopdata",
            element: <ShopData />,
          },
          {
            path: "menudata",
            element: <MenuData />,
          },
          {
            path: "customize",
            element: <Customize />,
          },
          {
            path: "products",
            element: <Products />,
          },
          {
            path: "settings",
            element: <Settings />,
          },
          {
            path: "plans",
            element: <Plans />,
          },
        ],
      },
      {
        path: "login",
        element: <Login />,
      },
      {
        path: "signup",
        element: <Signup />,
      },
      {
        path: "recover",
        element: <Recover />,
      }
    ]
  },
  {
    path: ":menuID",
    element: <Menu />,
  },
  {
    path: "*",
    element: <PageNotFound />
  }
])

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
    <RouterProvider router={router} />
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
